module.exports = __webpack_public_path__ + "static/HelveticaNeueLTW1G-Bd-a89a05af69da94d457d4be68827ae002.ttf";